import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function BrsrSectionCPopup({ isModalOpen, onClose }) {
  return (
    <Modal className="reports-modal input-modal" show={isModalOpen} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <h5 className="module-title">Select the relevant modules!</h5>
          <div className="row first-row">
            <div className="col-md-4">
              <div className="card essential">
                <div className="card-header">
                  <h5>Essential Indicators</h5>
                  <div>
                    <img src="/assets/img/reports/mandatory.svg" alt="Essential" />
                  </div>
                </div>

                <div className="card-body">
                  <p>These are the indicators that companies are mandatorily required to disclose under the BRSR framework. They represent the minimum baseline of ESG disclosures and are applicable to all specified entities to ensure standardisation, comparability, and regulatory compliance.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card leadership">
                <div className="card-header">
                  <h5>Leadership Indicators</h5>
                  <div>
                    <img src="/assets/img/reports/leadership.svg" alt="Leadership" />
                  </div>
                </div>

                <div className="card-body">
                  <p>These indicators are not mandatory to be reported by companies. They are intended to encourage advanced ESG practices, enhanced transparency, and stronger accountability. Disclosure of these indicators reflects a company’s leadership, maturity, and proactive approach towards sustainability.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card brsr-core">
                <div className="card-header">
                  <h5>BRSR Core</h5>
                  <div>
                    <img src="/assets/img/reports/brsr-core.svg" alt="BRSR Core" />
                  </div>
                </div>

                <div className="card-body">
                  <p>BRSR Core is a subset of standardized ESG KPIs spanning 9 ESG attributes. These KPIs are primarily mapped to Essential indicators under Section C of BRSR. Disclosure and assurance of BRSR Core KPIs are mandated for the top 1000 listed entities from FY 2026-27 onward.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <label htmlFor="doNotShowAgainBrsr" className="checkbox-label">
          <input
            type="checkbox"
            id="doNotShowAgainBrsr"
            name="doNotShowAgainBrsr"
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem("brsrSectionCPopup", "hide");
              } else {
                localStorage.setItem("brsrSectionCPopup", "show");
              }
            }}
          />
          Don't show this message again
        </label>
        <div className="button-group">
          <Button variant="outline-secondary" className="cancel-button" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" className="next-button" onClick={onClose}>
            Okay
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default BrsrSectionCPopup;
